const deliverySelectors = {
  container: '.delivery-estimation__container',
  delayContainer: '.delivery-estimation__delay-container',
  minimumDelay: '.delivery-estimation__datemin',
  maximumDelay: '.delivery-estimation__datemax',
  countdown: '.delivery-estimation__countdown',
  stockContainer: '.stock-disp-cont',
};

/**
 * @function estimateDeliveryDelay - require the current variant id
 *
 * @info Intégrer dans le JS du thème ce bout de code là ou le changement de variant est détecté
 *
 * const DeliveryEstimationClass = document.querySelector('delivery-estimation');
 * DeliveryEstimationClass.estimateDeliveryDelay(this.currentVariant.id);
 */
class DeliveryEstimation extends HTMLElement {
  constructor() {
    super();

    // this.deliveryContainer = document.querySelector(deliverySelectors.container);
    this.deliveryDelayContainer = this.querySelector(deliverySelectors.delayContainer);
    this.deliveryMinimumDelay = this.querySelector(deliverySelectors.minimumDelay);
    this.deliveryMaximumDelay = this.querySelector(deliverySelectors.maximumDelay);
    this.countdown = this.querySelector(deliverySelectors.countdown);
    this.stockContainer = this.querySelector(deliverySelectors.stockContainer);

    this.translation = JSON.parse(this.querySelector('[type="application/json"]').textContent);

    this.stock = {
      available: this.translation.stock_available,
      low: this.translation.stock_low,
    };

    this.date_format = this.translation.date_format;

    this.CSSClass = {
      available: 'stock-indic--available',
      low: 'stock-indic--low',
      out: 'stock-indic--out',
    };
  }

  connectedCallback() {
    this.setupListeners();
    this.init();
  }

  get variantId() {
    return this.stockContainer.dataset.currentVariantId;
  }

  set variantId(variantId) {
    this.stockContainer.dataset.currentVariantId = variantId;
  }

  setupListeners() {
    document.addEventListener('variant-change', this.onVariantChanged.bind(this));
  }

  init() {
    this.variantElms = document.querySelectorAll('.product-variant');
    this.variantsObj = [];

    this.variantElms.forEach((variantElm) => {
      this.variantsObj.push({
        id: variantElm.dataset.variantId,
        inventory_qty: variantElm.dataset.variantInventoryQty,
        inventory_policy: variantElm.dataset.variantInventoryPolicy,
      });
    });

    const currentVariantId = this.querySelector('.stock-disp-cont').dataset.currentVariantId;
    const varIndex = this.variantsObj.findIndex((o) => parseInt(o.id) === parseInt(currentVariantId));
    const varQuantity = parseInt(this.variantsObj[varIndex].inventory_qty);
    const varInventoryPolicy = this.variantsObj[varIndex].inventory_policy;
    const stockDisp = document.querySelector('.stock-disp');
    const stockIndic = document.querySelector('.stock-indic');

    if (stockIndic) {
      if (stockIndic.classList.contains(this.CSSClass.low)) stockIndic.classList.remove(this.CSSClass.low);
      if (stockIndic.classList.contains(this.CSSClass.out)) stockIndic.classList.remove(this.CSSClass.out);
      if (stockIndic.classList.contains(this.CSSClass.available)) stockIndic.classList.remove(this.CSSClass.available);
    }

    if (varInventoryPolicy == 'continue' || varQuantity > parseInt(this.stock.low)) {
      stockDisp.innerHTML = this.translation.available;
      stockIndic.classList.add(this.CSSClass.available);
    } else if (varQuantity <= parseInt(this.stock.low) && varQuantity > 0) {
      stockDisp.innerHTML = `${this.translation.low_before} ${varQuantity} ${this.translation.low_after}`;
      stockIndic.classList.add(this.CSSClass.low);
    } else if (varQuantity <= 0) {
      stockDisp.innerHTML = `${this.translation.unavailable}`;
      stockIndic.classList.add(this.CSSClass.out);
    }

    this.updateDeliveryDelay();

    if (this.countdown) {
      this.startCountdown();
    }
  }

  onVariantChanged(event) {
    this.variantId = event.detail.variant.id;
    this.init();
  }

  updateDeliveryDelay() {
    let today = new Date();
    let datesDelai;

    if (this.deliveryDelayContainer.dataset.max === '0') {
      datesDelai = this.getDatesDelai(today, parseInt(this.deliveryDelayContainer.dataset.min));
    } else {
      datesDelai = this.getDatesDelai(
        today,
        parseInt(this.deliveryDelayContainer.dataset.min),
        parseInt(this.deliveryDelayContainer.dataset.max),
      );
    }

    this.deliveryMinimumDelay.innerHTML = this.dateFrenchFormat(datesDelai['dmin']);

    if (this.deliveryDelayContainer.dataset.max !== '0') {
      this.deliveryMaximumDelay.innerHTML = this.dateFrenchFormat(datesDelai['dmax']);
    }
  }

  dateFrenchFormat(dateAConvertir) {
    var jours = new Array('Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi');
    var mois = new Array(
      'Janvier',
      'Février',
      'Mars',
      'Avril',
      'Mai',
      'Juin',
      'Juillet',
      'Août',
      'Septembre',
      'Octobre',
      'Novembre',
      'Décembre',
    );
    if (this.date_format === 'lettres') {
      var date = new Date(dateAConvertir);
      //var message = jours[date.getDay()] + ' ';
      var message = '';
      message += date.getDate() + ' ';
      message += mois[date.getMonth()] + ' ';
    } else {
      var date = new Date(dateAConvertir);
      var message = date.getDate() + '/';
      message += date.getMonth() + 1;
    }
    return message;
  }

  getDatesDelai(date1, delaiMin, delaiMax) {
    var result = new Array();
    var nbMin = typeof delaiMin != 'undefined' && delaiMin != null ? delaiMin : 2;
    var nbMax = typeof delaiMax != 'undefined' && delaiMax != null ? delaiMax : 2;
    var D = new Date(date1);
    var dMin = D.setDate(D.getDate() + nbMin);
    var dMax = D.setDate(D.getDate() + nbMax);
    var dateMin = new Date(dMin);
    var dateMax = new Date(dMax);

    if (dateMin.getDay() === 0 || dateMax.getDay() === 0) {
      D = new Date(date1);

      if (dateMin.getDay() === 0) {
        dMin = D.setDate(D.getDate() + nbMin + 1);
      } else {
        dMin = D.setDate(D.getDate() + nbMin);
      }
      if (dateMax.getDay() === 0) {
        dMax = D.setDate(D.getDate() + nbMax + 1);
      } else {
        dMax = D.setDate(D.getDate() + nbMax);
      }
    }

    if (this.checkIfIsValidDate(date1)) {
      result['dmin'] = dMin;
      nbMax ? (result['dmax'] = dMax) : null;
    } else {
      result = null;
    }
    return result;
  }

  checkIfIsValidDate(d) {
    return Object.prototype.toString.call(d) === '[object Date]' && !isNaN(d.getTime()) ? true : false;
  }

  startCountdown() {
    const targetTime = this.getTargetTimeInFrance();
    const currentTime = this.getCurrentTimeInFrance();
    const timeRemaining = this.getTimeDifferenceInMs(targetTime, currentTime);

    this.countdown.innerHTML = this.formatDuration(timeRemaining);
  }

  getCurrentTimeInFrance() {
    const FRANCE_UTC_OFFSET = 120;
    const today = new Date();
    const localOffset = today.getTimezoneOffset();
    const franceTime = new Date(today.getTime() + (FRANCE_UTC_OFFSET + localOffset) * 60000);
    return franceTime;
  }

  getTargetTimeInFrance() {
    const now = this.getCurrentTimeInFrance();
    const noonToday = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12, 0, 0);
    if (now < noonToday) {
      return noonToday;
    } else {
      const noonTomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 12, 0, 0);
      return noonTomorrow;
    }
  }

  getTimeDifferenceInMs(date1, date2) {
    return Math.abs(date1.getTime() - date2.getTime());
  }

  formatDuration(durationInMs) {
    const hours = Math.floor(durationInMs / (1000 * 60 * 60));
    const minutes = Math.floor((durationInMs % (1000 * 60 * 60)) / (1000 * 60));
    return `${hours} heures, ${minutes} minutes`;
  }
}

customElements.define('delivery-estimation', DeliveryEstimation);